/**
 * Reusable User Form Component
 * Used by the Edit Profile modal and the account dashboard
 */

import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { isValidTimeFormat, formatTime12Hour } from '../utils/helpers';

const UserForm = ({ formData, formErrors, onChange }) => {
  return (
    <Form>
      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="form-label-compact">Home Address</Form.Label>
            <Form.Control
              type="text"
              name="tenant"
              value={formData.tenant || ''}
              onChange={onChange}
              isInvalid={!!formErrors.tenant}
              className="form-control-compact"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.tenant}
            </Form.Control.Feedback>
            <Form.Text className="text-muted small helper-text-tiny">
              Identifies your household — this is also used for parking registration
              and the whole household logs in with it
            </Form.Text>
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="form-label-compact">Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name || ''}
              onChange={onChange}
              isInvalid={!!formErrors.name}
              className="form-control-compact"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.name}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={6} md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="form-label-compact">License Plate</Form.Label>
            <Form.Control
              type="text"
              name="license_plate"
              value={formData.license_plate || ''}
              onChange={onChange}
              isInvalid={!!formErrors.license_plate}
              className="form-control-compact"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.license_plate}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col xs={6} md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="form-label-compact">Phone Number *</Form.Label>
            <Form.Control
              type="text"
              name="phone_number"
              value={formData.phone_number || ''}
              onChange={onChange}
              isInvalid={!!formErrors.phone_number}
              className="form-control-compact"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.phone_number}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={6} md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="form-label-compact">Auto-register Time (HH:MM)</Form.Label>
            <Form.Control
              type="text"
              name="pref_time"
              value={formData.pref_time || ''}
              onChange={onChange}
              isInvalid={!!formErrors.pref_time}
              placeholder="19:00"
              className="form-control-compact"
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.pref_time}
            </Form.Control.Feedback>
            <Form.Text className="text-muted small helper-text-tiny">
              Registers daily at this time
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>

      {formData.pref_time && isValidTimeFormat(formData.pref_time) && (
        <Row className="mb-3">
          <Col>
            <Form.Text className="text-muted small">
              <i className="bi bi-clock me-1"></i>
              Daily at {formatTime12Hour(formData.pref_time)}
            </Form.Text>
          </Col>
        </Row>
      )}

      <div className="auto-register-toggle-wrapper mb-3">
        <Form.Check
          type="switch"
          name="auto_register"
          id={`auto-register-switch-${formData.name || 'new'}`}
          label="Auto-register Parking"
          checked={formData.auto_register || false}
          onChange={onChange}
        />
      </div>

    </Form>
  );
};

export default UserForm;
